export const fetchServiceList = async (sessionId: string) => {
	try {
		const formData = new FormData();

		formData.append('method', 'get_usluga_list');
		formData.append('session_id', sessionId);
		formData.append('get_user_uslugas_all', 'false');
		formData.append('get_user_uslugas', 'false');
		formData.append('get_setted', 'false');

		const API = import.meta.env.VITE_API_BASE_URL;
		const url = `${API}/carbon`;

		const response = await fetch(url, {
			method: 'POST',
			body: formData,
		});

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		const data = await response.json();

		return data;
	} catch (error) {
		console.error('Fetch error:', error);
		throw error;
	}
};
